export default {
  confirm: 'Confirm',
  cancel: 'Cancel',
  save: 'Save',
  noSave: "Don't Save",
  delete: 'Delete',
  edit: 'Edit',
  add: 'Add',
  search: 'Search',
  reset: 'Reset',
  back: 'Back',
  submit: 'Submit',
  loading: 'Loading...',
  noData: 'No Data',
  noMoreData: 'No More Data',
  success: 'Operation Successful',
  failed: 'Operation Failed',
  required: 'This field is required',
  development: 'In Development',
  underConstruction: 'Under Construction',
  all: 'All',
  operation: 'Operation',
  pleaseInputLanguage: 'Please Input Language',
  pleaseSelect: 'Please Select',
  pleaseInput: 'Please Input',
  upload: 'Upload',
  uploadVideo: 'Upload Video',
  uploadImage: 'Upload Image',
  previousStep: 'Previous Step',
  nextStep: 'Next Step',
  sort: 'Sort',
  multilingual: 'Multilingual',
  languageVersion: 'Language Version',
  select: 'Select',
  total: 'Total',
  item: 'item(s)',
  updatedAt: 'Updated At',
  current: 'Current',
  switch: 'Switch',
  copy: 'Copy',
  pleaseEnter: 'Please Enter',
  comingSoon: 'Coming Soon',
  home: 'Home',
  action: 'Action',
  warning: 'Warning',
  logout: 'Logout',
  logoutConfirm: 'Confirm Logout',
  logoutConfirmContent: 'Are you sure you want to log out?',
  user: 'User',
  adminTitle: 'Admin',
  selectField: 'Select Field',
  none: 'None',
  copySuccess: 'Copied',
  copyFailed: 'Copy failed',
  tip: 'Tip',
};
